import Vue from 'vue'
import Vuex from 'vuex'

import { isNaN } from 'lodash'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'cartInfo'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        cartCnt: 0
      },
      mutations: {
        SET_CART_CNT (state, cnt) {
          state.cartCnt = cnt
        }
      },
      actions: {
        async updateCartCnt ({ commit, dispatch }) {
          var httpObj = window.vue.getInstance('http')
          try {
            var listCartResult = await httpObj.busn.listCartCnt(this, {})
            if (listCartResult.data.status === 'OK') {
              commit('SET_CART_CNT', isNaN(listCartResult.data.data.totalCount) ? 0 : Number(listCartResult.data.data.totalCount))
            } else {
              commit('SET_CART_CNT', 0)
            }
          } catch (e) {
            console.log(e)
            commit('SET_CART_CNT', 0)
          }
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/cartInfo.js